var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWithBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38293 0 0 5.38293 0 12C0 18.6171 5.38293 24 12 24C18.6171 24 24 18.6171 24 12C24 5.38293 18.6171 0 12 0ZM17.25 12.9999H12.9999V17.25C12.9999 17.8021 12.5521 18.2499 12 18.2499C11.4479 18.2499 11.0001 17.8021 11.0001 17.25V12.9999H6.75C6.19794 12.9999 5.75006 12.5521 5.75006 12C5.75006 11.4479 6.19794 11.0001 6.75 11.0001H11.0001V6.75C11.0001 6.19794 11.4479 5.75006 12 5.75006C12.5521 5.75006 12.9999 6.19794 12.9999 6.75V11.0001H17.25C17.8021 11.0001 18.2499 11.4479 18.2499 12C18.2499 12.5521 17.8021 12.9999 17.25 12.9999Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWithBg);
export default __webpack_public_path__ + "static/media/plus-with-bg.baadd321.svg";
export { ForwardRef as ReactComponent };